import { Button, Grid, Stack, Typography } from '@mui/material'
import { useAppSelector } from 'app/hooks'
import DialogChangePassword from 'components/Dialogs/ChangePassword'
import EditInput from 'components/EditInput'
import EditName from 'components/EditName'
import { useState } from 'react'

export default function OrganizerIndex() {
  const id = useAppSelector((s) => s.UI.auth?.id)
  const organizer = useAppSelector((s) =>
    s.Organizer.list.find((f) => f.id === id || '')
  )
  const [changePassword, setChangePassword] = useState(false)
  if (!organizer) return null

  return (
    <>
      {changePassword && id && (
        <DialogChangePassword
          id={id}
          handleClose={() => setChangePassword(false)}
        />
      )}
      <Grid container spacing={1} mt={2}>
        <Grid item xs={12}>
          <Typography
            variant="h5"
            component="h2"
            sx={{ borderBottom: 2 }}
            fontWeight="bold"
          >
            団体情報
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Stack
            direction={{
              xs: 'column-reverse',
              md: 'row',
            }}
            spacing={1}
            alignItems={{
              xs: 'flex-start',
              md: 'center',
            }}
            justifyContent="space-between"
          >
            <Typography variant="h6" component="h3" fontWeight="bold">
              {organizer.unitName}
            </Typography>
          </Stack>
        </Grid>
        <Grid item xs={12} ml={1}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={7}>
              <Stack ml={1}>
                <EditInput
                  label="団体名"
                  value={organizer.unitName}
                  apiEndpoint={'/api/organizer/' + id}
                  fieldName="unitName"
                />
                <EditInput
                  label="団体名カナ"
                  value={organizer.unitKanaName}
                  apiEndpoint={'/api/organizer/' + id}
                  fieldName="unitKanaName"
                />
                <EditInput
                  label="所在地"
                  value={organizer.address}
                  apiEndpoint={'/api/organizer/' + id}
                  fieldName="address"
                />
                <EditInput
                  label="メールアドレス"
                  value={organizer.email}
                  apiEndpoint={'/api/organizer/' + id}
                  fieldName="email"
                />
                <EditInput
                  label="電話番号"
                  value={organizer.tel}
                  apiEndpoint={'/api/organizer/' + id}
                  fieldName="tel"
                />
                <EditName
                  label="担当者名"
                  apiEndpoint={'/api/organizer/' + id}
                  lastName={organizer.lastName}
                  firstName={organizer.firstName}
                />
              </Stack>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Button
            color="warning"
            variant="contained"
            size="small"
            onClick={() => setChangePassword(true)}
          >
            パスワード変更
          </Button>
        </Grid>
      </Grid>
    </>
  )
}
